
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flux-3-video-ai-generator",
      function () {
        return require("private-next-pages/flux-3-video-ai-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flux-3-video-ai-generator"])
      });
    }
  